import { Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import {
    ViewModelServiceContext, withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { SuccessNotification } from 'gw-components-platform-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import GroupSummary from '../../components/GroupSummary/GroupSummary';
import OrgInfoTable from '../../components/OrgInfoTable/OrgInfoTable';
import UsersList from '../../components/UsersList/UsersList';
import messages from './Administration.messages';
import metadata from './Administration.metadata.json5';
import styles from './Administration.module.scss';
import AgencyDetails from '../../components/AgencyDetails/AgencyDetails';
import EditPrimaryContact from '../../components/EditPrimaryContact/EditPrimaryContact';
import EditPLA from '../../components/EditPLA/EditPLA'
import EditMailingAddress from '../../components/EditMailingAddress/EditMailingAddress';
import EditAgencyMailingAddress from '../../components/EditAgencyMailingAddress/EditAgencyMailingAddress';
import EditCommissionsDirectDeposit from '../../components/EditCommissionsDirectDeposit/EditCommissionsDirectDeposit';
import AddAgency from '../../components/AddAgency/AddAgency';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import EFTInfoTable from '../../components/EFTInfoTable/EFTInfoTable';
import EFTContact from '../../components/EFTContact/EFTContact';

function Administration(props) {
    const { authUserData } = props;
    const { showAlert, showConfirm } = useModal();
    const history = useHistory();
    const agencyAdminRoles = {
        'OrganizationAdminRoleCode': 'POA-000',
        'CommunityAdminRoleCode': 'PCA-000',
        'EFTEnabledRoleCode': 'PEFTE-000'
    };
    const roles = [agencyAdminRoles.OrganizationAdminRoleCode, agencyAdminRoles.CommunityAdminRoleCode];
    const [isLoadingData, updateIsLoadingData] = useState(false);
    const [currentUserVM, setCurrentUserVM] = useState();
    const [showOrgInfo, setShowOrgInfo] = useState(false);
    const [showGroupSummary, setShowGroupSummary] = useState(false);
    const [showAgencyDetails, setShowAgencyDetails] = useState(false);
    const [showUserList, setShowUserList] = useState(false);
    const [showEditPrimaryContact, setShowEditPrimaryContact] = useState(false);
    const [showUserPage, setShowUserPage] = useState(false);
    const [showEditEftPage, setShowEditEftPage] = useState(false);
    const [showEftContactPage, setShowEftContactPage] = useState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const eftStatus = ['Not Enrolled', 'Failed']
    // const [firstOrganization, setFirstOrganization] = useState();
    const [masterGroup, setMasterGroup] = useState();
    const [agencyGroup, setAgencyGroup] = useState();
    // US26481 authentication function doesn't always return a header immediately
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const [usersList, setUsersList] = useState();
    const [showAddAgency, setShowAddAgency] = useState(false);
    const [tdiAddress, setTdiAddress] = useState();
    const [showEditPLA, setShowEditPLA] = useState(false);
    const [showEditMailing, setShowEditMailing] = useState(false);
    const [groupPublicID, setGroupPublicId] = useState();
    // US26488 setShowEditCommissionsDirectDeposit is true, makes direct deposit info visible
    const [showEditCommissionsDirectDeposit, setShowEditCommissionsDirectDeposit] = useState(false);
    const EDIT_COMISSIONS_DIRECT_PRODUCER_PAGE = 'editComissionsDirectDepositPage';
    //DE15291 - edit mailing address in agency details page
    const EDIT_AGENCY_MAILING_ADDRESS_MASTER_PAGE = 'editagencymailingaddress'
    const [showEditAgencyMailing, setShowEditAgencyMailing] = useState(false);
    const MASTER_GROUP_PAGE = 'masterGroupPage';
    const PRODUCER_GROUP_PAGE = 'producerGroupPage';
    const EDIT_PRIMARY_CONTACT_MASTER_PAGE = 'editPrimaryContactMasterPage';
    const EDIT_PRIMARY_CONTACT_PRODUCER_PAGE = 'editPrimaryContactProducerPage';
    const ORGANIZATION_ADMINISTRATORS_PAGE = 'organizationAdministratorsPage';
    const PRIMARY_LOCATION_ADDRESS_PRODUCER_PAGE = 'editPrimaryLocationProducerAddress';
    const PRIMARY_LOCATION_ADDRESS_MASTER_PAGE = 'editPrimaryLocationMasterAddress';
    const MAILING_ADDRESS_PRODUCER_PAGE = 'editMailingAddressProducerAddress';
    const MAILING_ADDRESS_MASTER_PAGE = 'editMailingAddressMasterAddress';
    const USER_PAGE = 'userPage'
    const EDIT_EFT_PAGE = 'editEFTPage';
    const EFT_CONTACT_PAGE = 'eftContactPage'
    const viewModelService = useContext(ViewModelServiceContext);

    const translator = useTranslator();

    const setVisibility = useCallback((page) => {
        switch (page) {
            case MASTER_GROUP_PAGE:
                setShowOrgInfo(true);
                setShowGroupSummary(true);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(false);
                setShowUserPage(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case PRODUCER_GROUP_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(true);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(true);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case EDIT_PRIMARY_CONTACT_MASTER_PAGE:
                setShowOrgInfo(true);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(true);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(false);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case EDIT_PRIMARY_CONTACT_PRODUCER_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(true);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(true);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case PRIMARY_LOCATION_ADDRESS_PRODUCER_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(true);
                setShowEditMailing(false);
                setShowAgencyDetails(true);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case PRIMARY_LOCATION_ADDRESS_MASTER_PAGE:
                setShowOrgInfo(true);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(true);
                setShowEditMailing(false);
                setShowAgencyDetails(false);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case MAILING_ADDRESS_PRODUCER_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(true);
                setShowAgencyDetails(true);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case MAILING_ADDRESS_MASTER_PAGE:
                setShowOrgInfo(true);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(true);
                setShowAgencyDetails(false);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case EDIT_AGENCY_MAILING_ADDRESS_MASTER_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(true);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(false);
                setShowEditAgencyMailing(true);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case ORGANIZATION_ADMINISTRATORS_PAGE:
                setShowOrgInfo(true);
                setShowGroupSummary(false);
                setShowUserList(true);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(false);
                setShowUserPage(false);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case USER_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(false);
                setShowUserPage(true);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case EDIT_COMISSIONS_DIRECT_PRODUCER_PAGE:
                setShowOrgInfo(true);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowEditPLA(false);
                setShowEditMailing(false);
                setShowAgencyDetails(false);
                setShowUserPage(false);
                setShowEditCommissionsDirectDeposit(true);
                setShowEditAgencyMailing(false);
                setShowEditEftPage(false);
                setShowEftContactPage(false);
                break;
            case EFT_CONTACT_PAGE:
                setShowOrgInfo(false);
                setShowGroupSummary(false);
                setShowUserList(false);
                setShowEditPrimaryContact(false);
                setShowAgencyDetails(true);
                setShowUserPage(false);
                setShowEditEftPage(true);
                setShowEftContactPage(true);
                break;
            default:
                break;
        }
    }, []);

    const loadUserGroupInfo = useCallback((publicID, page) => {
        const producerGroupViewModel = viewModelService.create({}, 'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.ProducerGroupDTO');
        setGroupPublicId(publicID);
        // Added calls related to tfpa 
        if (!_.isUndefined(authUserData) && !_.isUndefined(_.get(authUserData, 'associationName_TWIA')) &&
            (_.get(authUserData, 'associationName_TWIA') === 'twia')) {
            AgencyAdminService.loadGroupInfo(publicID, authHeader).then((theGroup) => {
                producerGroupViewModel.value = theGroup;
                setAgencyGroup(() => producerGroupViewModel);
                if (page === PRODUCER_GROUP_PAGE || page === ORGANIZATION_ADMINISTRATORS_PAGE) {
                    AgencyAdminService.getAgencyUsers(publicID, null,
                        authHeader).then((result) => {
                            setUsersList(result.items);
                            setVisibility(page);
                            setGroupPublicId(publicID);
                            updateIsLoadingData(false);
                        });
                } else {
                    setVisibility(page);
                    updateIsLoadingData(false);
                }
            }, (err) => {
                console.error('Error loading Group info request', err);
            });
        } else {
            AgencyAdminService.loadGroupInfo_tfpa(publicID, authHeader).then((theGroup) => {
                producerGroupViewModel.value = theGroup;
                setAgencyGroup(() => producerGroupViewModel);

                if (page === PRODUCER_GROUP_PAGE || page === ORGANIZATION_ADMINISTRATORS_PAGE) {
                    AgencyAdminService.getAgencyUsers_tfpa(publicID, null,
                        authHeader).then((result) => {
                            setUsersList(result.items);
                            setVisibility(page);
                            setGroupPublicId(publicID);
                            updateIsLoadingData(false);
                        });
                } else {
                    setVisibility(page);
                    updateIsLoadingData(false);
                }
            }, (err) => {
                console.error('Error loading Group info request', err);
            });
        }

    }, [authHeader, currentUserVM, setVisibility, viewModelService]);

    const loadTDIRegistration = useCallback((page) => {
        updateIsLoadingData(false);

        AgencyAdminService.loadUserOrgInfo(
            authHeader).then((response) => {

                if (response) {
                    AgencyAdminService.loadTDIRegistration(authHeader)
                        .then((agency) => {
                            setTdiAddress(agency.agencyAddresses)

                            setVisibility(page);
                            updateIsLoadingData(false);

                        });
                } else {
                    updateIsLoadingData(false);
                }
            })
    }, [authHeader, setVisibility]);

    const createUserVM = useCallback((response) => {
        const currentUserViewModel = viewModelService?.create(response, 'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.UserDTO');

        setCurrentUserVM(() => currentUserViewModel);

        const masterGroupValue = _.find(currentUserViewModel.producerGroupsSummary_EXT.children,
            (summary) => summary.value.isMasterGroup)

        setMasterGroup(() => masterGroupValue);

        if (_.isUndefined(masterGroupValue)) {
            // Revert DE19048
            // if(currentUserViewModel.producerGroupsSummary_EXT.value?.length > 0){
                loadUserGroupInfo(currentUserViewModel.producerGroupsSummary_EXT
                    .value[0].publicID, PRODUCER_GROUP_PAGE)
            // }
            // else{
            //     setVisibility(MASTER_GROUP_PAGE)
            //     updateIsLoadingData(false);
            // }
        } else {
            setVisibility(MASTER_GROUP_PAGE)
            updateIsLoadingData(false);
        }
    }, [loadUserGroupInfo, setVisibility, viewModelService]);

    useEffect(() => {
        // US26481 check for auth header before calling any services
        if (authHeader) {
            updateIsLoadingData(true);

            AgencyAdminService.userHasEitherRolesByCode(roles,
                authHeader).then((response) => {
                    if (response) {
                        AgencyAdminService.loadUserOrgInfo(authHeader)
                            .then((result) => {
                                createUserVM(result);
                            });
                    } else {
                        updateIsLoadingData(false);
                    }
                })
        }
    }, [authHeader]);

    const getNotificationContent = useCallback(() => ({
        infoMessageDescription: translator(messages.changesMade),
        optionalInfoMessageDescription: translator(messages.youMay)
    }), [translator]);

    const getAdministrators = useCallback(() => {
        updateIsLoadingData(true);

        // Revert - 19048
        // // DE19048
        // if(_.isUndefined(masterGroup)){
        //     updateIsLoadingData(false);
           
        //     return
        // }

        // DE15287
        loadUserGroupInfo(masterGroup.publicID.value, PRODUCER_GROUP_PAGE)
    }, [loadUserGroupInfo, masterGroup]);

    const editAgencyInfo = useCallback((groupSummary) => {
        updateIsLoadingData(true);

        // Revert - 19048
        // // DE19048
        // if(_.isUndefined(masterGroup)){
        //     updateIsLoadingData(false);
           
        //     return
        // }   

        loadUserGroupInfo(groupSummary.row.publicID, PRODUCER_GROUP_PAGE);
    }, [loadUserGroupInfo]);

    const editPrimaryContact = useCallback((producerVM) => {
        updateIsLoadingData(true);

        // DE15328
        if (producerVM && !producerVM.isMasterGroup.value) {
            loadUserGroupInfo(producerVM.publicID.value, EDIT_PRIMARY_CONTACT_PRODUCER_PAGE);
        } else if (masterGroup.publicID) {
            loadUserGroupInfo(masterGroup.publicID.value, EDIT_PRIMARY_CONTACT_MASTER_PAGE);
        }
    }, [loadUserGroupInfo, masterGroup]);

    //DE15291 - Function for edit mailing address in agency details page
    const editAgencyMailingAddress = useCallback((producerVM) => {
        updateIsLoadingData(true);

        // DE15386
        if (producerVM && !producerVM.isMasterGroup.value) {
            loadUserGroupInfo(producerVM.publicID.value, EDIT_AGENCY_MAILING_ADDRESS_MASTER_PAGE);
        }
        else {
            loadTDIRegistration(MAILING_ADDRESS_MASTER_PAGE);
        }
    }, [loadTDIRegistration, loadUserGroupInfo]);

    const editPrimaryLocationAddress = useCallback((producerVM) => {
        updateIsLoadingData(true);

        if (producerVM) {
            loadTDIRegistration(PRIMARY_LOCATION_ADDRESS_PRODUCER_PAGE);
        }
        else {
            loadTDIRegistration(PRIMARY_LOCATION_ADDRESS_MASTER_PAGE);
        }
    }, [loadTDIRegistration]);

    const editMailingddress = useCallback((producerVM) => {
        updateIsLoadingData(true);

        if (producerVM) {
            loadTDIRegistration(MAILING_ADDRESS_PRODUCER_PAGE);
        }
        else {
            loadTDIRegistration(MAILING_ADDRESS_MASTER_PAGE);
        }
    }, [loadTDIRegistration]);

    const updatePrimaryContact = useCallback((producer, group) => {
        updateIsLoadingData(true);

        if (group.isMasterGroup.value) {
            AgencyAdminService.updatePrimaryContact(currentUserVM.organization_EXT.publicID.value,
                producer.publicID, authHeader).then(() => {
                    AgencyAdminService.loadUserOrgInfo(authHeader)
                        .then((result) => {
                            createUserVM(result);
                        });
                });
        } else {
            AgencyAdminService.updatePrimaryContactForProducerGroup(group.publicID.value,
                producer.publicID, authHeader).then(() => {
                    AgencyAdminService.loadUserOrgInfo(authHeader)
                        .then((result) => {
                            createUserVM(result);
                        });
                });
        }
    }, [authHeader, createUserVM, currentUserVM]);

    // US26490 To update the Location and Mailing address
    // DE15378
    const updatelocationAddress = useCallback((editAddress) => {
        updateIsLoadingData(true);

        if (currentUserVM.organization_EXT.value) {
            _.set(currentUserVM, 'organization_EXT.primaryLocationAddress_TWIA', editAddress.agencyAddresses.value)
            AgencyAdminService.updateOrganization(currentUserVM.organization_EXT.value, authHeader).then((result) => {
                currentUserVM.organization_EXT.value = result
                history.go('/administration');
            })
        }
    }, [authHeader, currentUserVM, history]);

    const updateMailingAddress = useCallback((editAddress) => {
        updateIsLoadingData(true);

        if (currentUserVM.organization_EXT.value) {
            _.set(currentUserVM, 'organization_EXT.primaryPersonContact.primaryAddress', editAddress.agencyAddresses.value)
            AgencyAdminService.updateOrganization(currentUserVM.organization_EXT.value, authHeader).then((result) => {
                currentUserVM.organization_EXT.value = result
                history.go('/administration');
            })
        }
    }, [authHeader, currentUserVM, history]);

    // DE15378
    const updateAgencyMailingAddress = useCallback(() => {
        updateIsLoadingData(true);

        if (!agencyGroup.reasonDescription_Ext.value) {
            _.set(agencyGroup, 'reasonDescription_Ext.value', '');
            AgencyAdminService.updateProducerGroup(agencyGroup.value, authHeader).then((result) => {
                agencyGroup.value = result
                //DE15381
                setVisibility(PRODUCER_GROUP_PAGE);
                updateIsLoadingData(false);
            })
        }
    }, [agencyGroup, authHeader, history]);

    // US26488 setting visibility to enable direct deposit info 
    const editComissionsDirectDeposit = useCallback(() => {
        setVisibility(EDIT_COMISSIONS_DIRECT_PRODUCER_PAGE);
    }, [setVisibility]);

    const setUserPageVisible = useCallback(() => {
        setVisibility(USER_PAGE)
    }, [setVisibility]);

    const getAddAgencyContent = useCallback((value) => {
        setShowAddAgency(value);

        if (value == true) {
            setShowGroupSummary(false);
            setShowAgencyDetails(false);
            setShowOrgInfo(false);

        } else {
            setShowGroupSummary(true);
            setShowAgencyDetails(true);
            setShowOrgInfo(true);
        }

    }, [showAddAgency, showAgencyDetails, showGroupSummary])

    // US26489
    const editEftPaymentInfo = useCallback(() => {
        setVisibility(EFT_CONTACT_PAGE);
    }, [setVisibility]);

    const onCancelEFT = useCallback(() => {
        showConfirm({
            title: messages.changesNotSaved,
            message: messages.exitWithoutSubmit,
            // status: 'warning',
            // icon: 'gw-help',
            confirmButtonText: messages.ok,
            cancelButtonText: messages.cancel,
        }).then(results => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            updateIsLoadingData(true);
            loadUserGroupInfo(agencyGroup.publicID.value, PRODUCER_GROUP_PAGE);
        }, _.noop);
    }, [agencyGroup, loadUserGroupInfo, showConfirm]);

    const onDeactivateEFT = useCallback((group) => {
        showConfirm({
            title: messages.deactivatePopupTitle,
            message: messages.deactivatePopupMsg,
            // status: 'warning',
            // icon: 'gw-help',
            confirmButtonText: messages.ok,
            cancelButtonText: messages.cancel,
        }).then(results => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            updateIsLoadingData(true);
        _.set(group, 'reasonDescription_Ext.value', '');

        const notenrolled = _.includes(eftStatus, _.get(group, 'eftenrollmentStatus.value'));

        if (notenrolled) {
            _.set(group, 'agentEFT_TWIA.acceptTerms.value', true)
        }

        AgencyAdminService.deactivateEFT(group.value, authHeader).then(() => {
            loadUserGroupInfo(group.publicID.value, PRODUCER_GROUP_PAGE);
        }).catch(() => {
            updateIsLoadingData(false);

            showAlert({
                title: messages.activateFailTitle,
                message: messages.activateFail,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: messages.ok,
            })
        });
        }, _.noop);
    }, [authHeader, eftStatus, loadUserGroupInfo, showAlert, showConfirm]);

    const onActivateEFT = useCallback((group) => {
        updateIsLoadingData(true);
        _.set(group, 'reasonDescription_Ext.value', '');

        const notenrolled = _.includes(eftStatus, _.get(group, 'eftenrollmentStatus.value'));

        if (notenrolled) {
            _.set(group, 'agentEFT_TWIA.acceptTerms.value', true)
        }

        AgencyAdminService.activateEFT(group.value, authHeader).then(() => {
            loadUserGroupInfo(group.publicID.value, PRODUCER_GROUP_PAGE);
        }).catch(() => {
            updateIsLoadingData(false);

            showAlert({
                title: messages.activateFailTitle,
                message: messages.activateFail,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: messages.ok,
            })
        });
    }, [authHeader, eftStatus, loadUserGroupInfo, showAlert]);

    const onSubmitEFT = useCallback((group) => {
        updateIsLoadingData(true);
        _.set(group, 'reasonDescription_Ext.value', '');

        // DE18219 'Failed' status can exist on migrated agencies
        const notenrolled = _.get(group, 'eftenrollmentStatus.value') === 'Not Enrolled';

        if (!notenrolled) {
            _.set(group, 'agentEFT_TWIA.acceptTerms.value', true)
        }

        AgencyAdminService.updateEFTPaymentInfo(group.value, authHeader).then(() => {
            loadUserGroupInfo(group.publicID.value, PRODUCER_GROUP_PAGE);
        }).catch((err) => {
            updateIsLoadingData(false);

            const errorCode = _.get(err, 'baseError.error.data.appErrorCode');

            switch (errorCode) {
                case 10075:
                    showAlert({
                        title: messages.invalidBank,
                        message: messages.badBank,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok,
                    })
                    break;
                default:
                    showAlert({
                        title: messages.updateFailTitle,
                        message: messages.updateFailMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok,
                    })
                    break;
            }
        });
    }, [authHeader, eftStatus, loadUserGroupInfo, showAlert]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        infoMessage: {
            type: 'info',
            notificationContent: getNotificationContent(),
            addbreak: true
        },
        orgInfo: {
            visible: !_.isUndefined(currentUserVM) && showOrgInfo,
            userVM: currentUserVM,
            editPrimaryContact,
            editPrimaryLocationAddress,
            editMailingddress,
            editComissionsDirectDeposit
        },
        groupSummary: {
            visible: !_.isUndefined(currentUserVM) && showGroupSummary,
            userVM: currentUserVM,
            getAdministrators,
            editAgencyInfo,
            getAddAgencyContent: getAddAgencyContent
        },
        agencyDetails: {
            visible: !_.isUndefined(agencyGroup) && showAgencyDetails,
            producerVM: agencyGroup,
            userVM: currentUserVM, // DE15288
            editPrimaryContact,
            editPrimaryLocationAddress,
            editMailingddress,
            editAgencyMailingAddress,
            editEftPaymentInfo
        },
        usersList: {
            visible: !_.isUndefined(currentUserVM) && showUserList,
            userVM: currentUserVM,
            usersData: usersList,
            showUserInfo: showUserPage,
            groupPublicID: groupPublicID,
            setShowUserInfo: setUserPageVisible,
            showUserList: showUserList,
            group: agencyGroup,
            associationName_TWIA: _.get(authUserData, 'associationName_TWIA')
        },
        editPrimaryContact: {
            visible: !_.isUndefined(agencyGroup) && showEditPrimaryContact,
            group: agencyGroup,
            userVM: currentUserVM,
            updatePrimaryContact,
            usersData: usersList,
            groupPublicID: groupPublicID,
            associationName_TWIA: _.get(authUserData, 'associationName_TWIA')
        },
        editPLA: {
            visible: showEditPLA,
            group: agencyGroup,
            userVM: currentUserVM,
            tdiAddress,
            updatelocationAddress
        },
        editMailingAddress: {
            visible: showEditMailing,
            group: agencyGroup,
            userVM: currentUserVM,
            tdiAddress,
            updateMailingAddress
        },
        editAgencyMailingAddress: {
            visible: showEditAgencyMailing,
            group: agencyGroup,
            userVM: currentUserVM,
            updateAgencyMailingAddress
        },
        editCommissionsDirectDeposit: {
            visible: showEditCommissionsDirectDeposit,
            userVM: currentUserVM,
        },
        addAgency: {
            visible: showAddAgency,
            getAddAgencyContent: getAddAgencyContent,
            associationName_TWIA: _.get(authUserData, 'associationName_TWIA') //DE15365
        },
        eftInfoTable: {
            visible: showEditEftPage,
            group: agencyGroup,
            userVM: currentUserVM,
        },
        eftContact: {
            visible: showEftContactPage,
            group: agencyGroup,
            userVM: currentUserVM,
            onCancelEFT,
            onSubmitEFT,
            onActivateEFT,
            onDeactivateEFT
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            successNotifcationComponent: SuccessNotification,
            orgInfoComponent: OrgInfoTable,
            groupSummaryComponent: GroupSummary,
            agencyDetailsComponent: AgencyDetails,
            userslistComponent: UsersList,
            editPrimaryContactComponent: EditPrimaryContact,
            editPLAComponent: EditPLA,
            editMailingAddressComponent: EditMailingAddress,
            editAgencyMailingAddressComponent: EditAgencyMailingAddress,
            editCommissionsDirectDepositComponent: EditCommissionsDirectDeposit,
            addAgencyComponent: AddAgency,
            eftInfoTableComponent: EFTInfoTable,
            eftContactComponent: EFTContact
        },
        resolveCallbackMap: {

        },
    };

    return (
        <Loader loaded={!isLoadingData}>
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                {...resolvers}
            />
        </Loader>
    );
}

Administration.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

Administration.defaultProps = {

};

export default withViewModelService(withAuthenticationContext(withRouter(Administration)));
